import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class DetailComparisonService {
  private loginUrl:string;

  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { this.loginUrl = this.env.servicePath }

  getDetailComparisonInfo(id:string){
    var path = this.loginUrl +"GetDetailComparisonInfo/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  getDetailComparisonGroup(id:string, groupName: string){
    var path = this.loginUrl +"GetDetailComparisonGroup/"+id+"/"+groupName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  detailComparisonUpdateValue(id:string, groupName: string, headerName: string, value: any){
    var path = this.loginUrl +"DetailComparisonUpdateValue/"+id+"/"+groupName+"/"+headerName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, value, httpOptions);
  }

  detailComparisonAction(id:string, actionName: string, param: any = null){
    var path = this.loginUrl +"DetailComparisonAction/"+id+"/"+actionName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text','Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  getFileCompareObject(id:string, definitionName: string, sheetName: string, data: any){
    var path = this.loginUrl +"GetFileCompareObject/"+id + "/" + definitionName + "?sheetName=" + sheetName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, data, httpOptions);
  }
}
